<template>
  <v-app>
    <!-- Component detacts online/offline mode. If only running in Chrome, the network api is even more powerful. -->
    <v-offline
      online-class="online"
      offline-class="offline"
      @detected-condition="detactOnlineStatus"
    ></v-offline>

    <v-main v-if="onlineStatus == 'online'">
      <router-view />
    </v-main>

    <v-main>
      <v-alert
        type="error"
        color="#ff643c"
        v-if="onlineStatus == 'offline'"
        id="offline"
        class="space-text"
      >
        <b>{{ $t("offline_notification") }}</b>
        <p>{{ $t("online_recommendation") }}</p>
      </v-alert>
    </v-main>
  </v-app>
</template>

<script>
import VOffline from "v-offline";
import config from "./configuration.json";

export default {
  name: "App",
  components: {
    VOffline,
  },
  data() {
    return {
      analyticsDataLayer: {
        app_id: "com.schott.corporate.pwa.wfmplanner",
        app_name: "WFM Planner",
        name: "Start",
        screen_name: "Start",
        uri: "/",
        pageType: "landingpage",
        isLoggedIn: this.$store.getters.profile != undefined,
        pageTags: ["wfm", "shiftplan", "hr"],
        targetGroup: "customers",
        businessUnit: "LP",
        websiteBusiness: "employeeProductivity",
        branded: "unbranded",
        stage: config.stage,
      },
      onlineStatus: "online",
      onlineSlot: "online",
      offlineSlot: "offline",
    };
  },
  created() {
    this.trackUserContext();
  },
  methods: {
    isPageActive: function (route) {
      return this.$router.currentRoute.path == route;
    },
    loadPage: function (route) {
      if (!this.isPageActive(route)) {
        this.$router.push(route);
      }
    },
    login: async function () {
      let dl = this.analyticsDataLayer;
      dl["event_category"] = "click";
      dl["event_label"] = "Button Click / Login";

      this.$parent.$appInsights.trackEvent(dl.event_label, dl);
      this.$parent.$appInsights.flush();
      this.$parent.$gtag.event(dl.event_label, dl);

      this.$store.dispatch("loginWithSchottId");
    },
    async logout() {
      this.$appInsights.clearAuthenticatedUserContext();

      let dl = this.analyticsDataLayer;
      dl["event_category"] = "click";
      dl["event_label"] = "Button Click / Logout";

      this.$parent.$appInsights.trackEvent(dl.event_label, dl);
      this.$parent.$appInsights.flush();
      this.$parent.$gtag.event(dl.event_label, dl);

      this.$store.dispatch("logout");
    },
    detactOnlineStatus(e) {
      this.onlineStatus = e ? "online" : "offline";
    },
    /**
     * Track user context when user session exists
     */
    trackUserContext: function () {
      //User is logged in and has a valid profile
      if (this.$store.getters.profile !== undefined) {
        //Check if user is assigned to an account = is validated
        if (
          this.$store.getters.profile[
            "urn:sap:cloud:scim:schemas:extension:custom:2.0:User"
          ] !== undefined &&
          this.$store.getters.profile[
            "urn:sap:cloud:scim:schemas:extension:custom:2.0:User"
          ].attributes[0] !== undefined
        ) {
          this.$appInsights.setAuthenticatedUserContext(
            this.$store.getters.profile.id,
            this.$store.getters.profile[
              "urn:sap:cloud:scim:schemas:extension:custom:2.0:User"
            ].attributes[0].value,
            true
          );

          this.$gtag.set({
            user_id: this.$store.getters.profile.id,
            account_id: this.$store.getters.profile[
              "urn:sap:cloud:scim:schemas:extension:custom:2.0:User"
            ].attributes[0].value,
          });
        } else {
          this.$appInsights.setAuthenticatedUserContext(
            this.$store.getters.profile.id,
            true
          );
          this.$gtag.set({ user_id: this.$store.getters.profile.id });
        }
      }

      let dl = this.analyticsDataLayer;
      dl["event_category"] = "screenview";
      dl["event_label"] = "Screen View / " + this.analyticsDataLayer.name;

      this.$parent.$appInsights.trackEvent(dl.event_label, dl);
      this.$parent.$appInsights.flush();
      this.$parent.$gtag.event(dl.event_label, dl);
    },
  },
};
</script>
